export const INVOICE_KEYS = [
  { value: 0, label: 'Text' },
  { value: 1, label: 'Number' },
  { value: 2, label: 'Textarea' }
];
